export function assessLogo(data: Uint8ClampedArray, width: number, height: number) {
  if (width === 0 || height === 0) {
    return { contentWidth: 0, contentHeight: 0, touchesSideEdge: false };
  }

  const bgR = data[0];
  const bgG = data[1];
  const bgB = data[2];
  const bgA = data[3];

  let minX = width;
  let maxX = -1;
  let minY = height;
  let maxY = -1;
  const colContentCount = new Int32Array(width);

  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const idx = (y * width + x) * 4;
      const r = data[idx];
      const g = data[idx + 1];
      const b = data[idx + 2];
      const a = data[idx + 3];

      let isContent = false;
      if (a !== 0) {
        if (
          Math.abs(a - bgA) > 40 ||
          Math.abs(r - bgR) > 40 ||
          Math.abs(g - bgG) > 40 ||
          Math.abs(b - bgB) > 40
        ) {
          isContent = true;
        }
      }

      if (isContent) {
        if (x < minX) minX = x;
        if (x > maxX) maxX = x;
        if (y < minY) minY = y;
        if (y > maxY) maxY = y;
        colContentCount[x]++;
      }
    }
  }

  const contentWidth = maxX >= minX ? maxX - minX + 1 : 0;
  const contentHeight = maxY >= minY ? maxY - minY + 1 : 0;

  const threshold = height * 0.03;
  let touchesSideEdge = false;

  const trIdx = (width - 1) * 4;
  const blIdx = (height - 1) * width * 4;
  const brIdx = ((height - 1) * width + width - 1) * 4;

  const isSolidOpaqueBackground =
    bgA > 200 &&
    data[trIdx + 3] > 200 &&
    data[blIdx + 3] > 200 &&
    data[brIdx + 3] > 200 &&
    Math.abs(data[trIdx] - bgR) <= 40 &&
    Math.abs(data[trIdx + 1] - bgG) <= 40 &&
    Math.abs(data[trIdx + 2] - bgB) <= 40 &&
    Math.abs(data[blIdx] - bgR) <= 40 &&
    Math.abs(data[blIdx + 1] - bgG) <= 40 &&
    Math.abs(data[blIdx + 2] - bgB) <= 40 &&
    Math.abs(data[brIdx] - bgR) <= 40 &&
    Math.abs(data[brIdx + 1] - bgG) <= 40 &&
    Math.abs(data[brIdx + 2] - bgB) <= 40;

  if (isSolidOpaqueBackground) {
    touchesSideEdge =
      colContentCount[0] > threshold || colContentCount[width - 1] > threshold;
  }

  return { contentWidth, contentHeight, touchesSideEdge };
}
